import {useRecoilValue} from "recoil";
import {generateUid, splitUid} from "../../utils/ApplicationUtils";
import {ComplectationBlock, OptionsSelected} from "../../data";
import {
    stateSelectedAccessories,
    stateSelectedComplectations,
    stateAccessoriesBlocks,
    stateComplectationBlocks,
} from "../../data/atoms";


export const usePrice = () => {
    const complectations = useRecoilValue(stateComplectationBlocks);
    const accessories = useRecoilValue(stateAccessoriesBlocks);

    const selectedComplectations = useRecoilValue(stateSelectedComplectations);
    const selectedAccessories = useRecoilValue(stateSelectedAccessories);

    try {
        const priceComplectations = getPriceFromSelected(complectations, selectedComplectations);
        const priceAccessories = getPriceFromSelected(accessories, selectedAccessories);

        return priceComplectations + priceAccessories;
    } catch (err: unknown) {
        return 0;
    }
};


const getPriceFromSelected = (blocks: ComplectationBlock[], selected: OptionsSelected) => {
    const tree = Object.keys(selected).reduce<Record<string, Record<string, number>>>((total, current) => {
        const [blockUid, attributeUid, slotUid] = splitUid(current);

        const itemUid = slotUid ? generateUid(blockUid, slotUid) : blockUid;

        const value = selected[current]?.id;

        if (value) {
            total[itemUid] = total[itemUid]
                ? {...total[itemUid], [attributeUid]: value}
                : {[attributeUid]: value};
        }

        return total;
    }, {});

    return Object.keys(tree).reduce((total, current) => {
        const [currentBlockUid] = splitUid(current);
        const complectation = blocks.find((block) => block.id === current || block.id === currentBlockUid);

        const item = complectation?.items.find((item) => {
            const keysAttrs = Object.keys(item.attributes);
            const keysSelected = Object.keys(tree[current]);

            const isSameLength = keysAttrs.length === keysSelected.length;
            const isSameValues = keysSelected.every(key => tree[current][key] === item.attributes[key].id);

            return isSameLength && isSameValues;
        }) || null;

        return item
            ? total + item.price
            : total;
    }, 0);
};
